module.exports = __webpack_public_path__ + "img/image.e465c39e.svg";